import React from 'react';
import { styled } from 'utils/styles';
import { Trans } from 'utils/i18next';
import { ButtonLink } from 'components/common';

interface MidRateSimpleDisclaimerProps {
	onClick: () => void;
}

const BlueBox = styled.div`
	margin-top: 12px;
	margin-bottom: 12px;

	.sm-12 {
		padding-left: 0;
		padding-right: 0;
	}

	.notification-banner .A-PNLINLNEMSGE-RW-ALL {
		padding: 0.2rem 0.2rem 0.2rem 0.2rem;
		width: 90%;
		box-sizing: border-box;
	}

	.A-PNLINLNEMSGE-RW-ALL {
		background: rgba(55, 103, 152, 0.15);
		border: 1px solid #376798;
	}

	.notification-banner .A-PNLINLNEMSGE-RW-ALL .notification-banner-icon {
		line-height: 1;
	}

	.notification-banner .A-PNLINLNEMSGE-RW-ALL .notification-banner-text,
	.notification-banner .A-PNLINLNEMSGE-RW-ALL .notification-banner-icon {
		display: table-cell;
	}

	.notification-banner-icon svg {
		width: 24px;
		height: 24px;
	}

	.notification-banner .A-PNLINLNEMSGE-RW-ALL .notification-banner-text,
	.notification-banner .A-PNLINLNEMSGE-RW-ALL .notification-banner-icon {
		display: table-cell;
	}

	.notification-banner .A-PNLINLNEMSGE-RW-ALL .notification-banner-text p {
		margin-top: 2px;
		margin-bottom: 2px;
	}

	@media (min-width: 960px) {
		.notification-banner .A-PNLINLNEMSGE-RW-ALL .notification-banner-text {
			padding: 0 1.25rem 0 0.625rem;
		}
	}

	@media (min-width: 480px) {
		.notification-banner .A-PNLINLNEMSGE-RW-ALL .notification-banner-text {
			padding: 0 1.125rem 0 0.5625rem;
		}
	}

	.notification-banner .A-PNLINLNEMSGE-RW-ALL .notification-banner-text {
		text-align: left;
		padding: 0 0.5rem 0 0.4375rem;
		color: #333;
		line-height: 1.2;
		overflow: hidden;
		max-width: 90%;
		vertical-align: middle;
	}
`;

export const MidRateSimpleDisclaimer = (props: MidRateSimpleDisclaimerProps) => {
	const { onClick } = props;

	return (
		<BlueBox>
			<div id="pp_notificationBanner_1" className="sm-12">
				<section className="notification-banner O-SMARTSPCGEN-DEV">
					<div className="A-PNLINLNEMSGE-RW-ALL">
						<div className="notification-banner-icon">
							<svg
								focusable="false"
								className="fill"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 20 20"
							>
								{' '}
								<path
									fill="#376798"
									d="M10 4c-3.3 0-6 2.7-6 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6zm-.8 2h1.5v1.5H9.2V6zm2 7.5H8.8v-1.1h.5V9.5h-.5v-1h2v3.9h.5v1.1z"
								></path>{' '}
							</svg>
						</div>
						<div className="notification-banner-text A-TYP16R-RW-ALL">
							<p>
								<Trans i18nKey="disclaimers.midRateSimple">
									<b>Please note:</b> Rates available to customers will be subject
									to additional costs.
									<ButtonLink onClick={onClick}>Read more</ButtonLink>
								</Trans>
							</p>
						</div>
					</div>
				</section>
			</div>
		</BlueBox>
	);
};
